(function() { window.GUID_11d6178b_21b3_454f_b122_aa4cfa43cd6c = { getGuid: function() { return "11d6178b-21b3-454f-b122-aa4cfa43cd6c"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var App;
    (function (App) {
        var Views;
        (function (Views) {
            var _Shared;
            (function (_Shared) {
                var WallSections;
                (function (WallSections) {
                    class EventsFilteredSection extends WallSections.FilteredSection {
                        static get instance() {
                            if (!EventsFilteredSection._instance)
                                EventsFilteredSection._instance = new EventsFilteredSection();
                            return EventsFilteredSection._instance;
                        }
                        constructor() {
                            super();
                            this.DistanceKm = 30000;
                        }
                        get isWallLayout() {
                            return true; //$("#EventsWallLayout").val() == "True";
                        }
                        get filtersCount() {
                            return $("#EventsFilteredActiveFilters").val();
                        }
                        get accordionChildSelector() {
                            return "#filters-events-filtered";
                        }
                        onFilterChanged(url) {
                            return __awaiter(this, void 0, void 0, function* () {
                                if (this.markers) {
                                    for (let i = 0; i < this.markers.length; i++) {
                                        this.markers[i].setMap(null);
                                    }
                                    this.markers = null;
                                }
                                if (this.radiusCircle) {
                                    this.radiusCircle.setMap(null);
                                    this.radiusCircle = null;
                                }
                                if (this.markerClusterer) {
                                    this.markerClusterer.clearMarkers();
                                }
                                try {
                                    const $input = CS.DOM.$body.find(".textbox-main-search.searchbar__input");
                                    if ($input.length) {
                                        const _filtersState = yield CS.Controls.Filters.ExtractFiltersStateFromUrl(url);
                                        const _decompressedFiltersState = yield CS.Helper.gZipDecompress(_filtersState);
                                        const filtersState = JSON.parse(_decompressedFiltersState);
                                        if (!filtersState)
                                            throw new Error("filtersState is null");
                                        const { FilterItems } = filtersState;
                                        if (FilterItems && Array.isArray(FilterItems) && FilterItems.length) {
                                            const nameFilterItem = FilterItems.find((f) => f.Type == CS.Enumeration.FilterType.Name);
                                            if (nameFilterItem) {
                                                const IsActive = nameFilterItem.IsActive;
                                                const Value = nameFilterItem.Value;
                                                if (!IsActive || CS.Helper.isNullOrWhiteSpace(Value)) {
                                                    $input.val("");
                                                }
                                                else {
                                                    $input.val(Value);
                                                }
                                                const $watermark = $input
                                                    .parent()
                                                    .find(".textbox-main-search-watermark .search-here");
                                                if ($watermark.length) {
                                                    CS.Views.MainSearch.RefreshVisibilityWatermark($input, $watermark);
                                                }
                                            }
                                        }
                                    }
                                }
                                catch (error) {
                                    console.error("Error while parsing filtersState: ", error);
                                }
                            });
                        }
                        onBeforeUIRefresh() {
                            if (this.map) {
                                this.oldMapInstance = $("#map").remove();
                            }
                        }
                        initMap() {
                            let me = this;
                            const newMap = $("#map");
                            if (newMap.length == 0) {
                                return;
                            }
                            if (me.oldMapInstance) {
                                me.oldMapInstance.insertBefore(newMap);
                                me.oldMapInstance = null;
                                newMap.remove();
                            }
                            if (typeof google != "object" || me.markers) {
                                return;
                            }
                            me.Position = new google.maps.LatLng(CS.CommonData.Current.Latitude, CS.CommonData.Current.Longitude);
                            if (!this.map) {
                                this.map = new google.maps.Map(document.getElementById("map"), { mapId: "97c6b6c44d5de807" });
                                // Add a marker clusterer to manage the markers.
                                this.markerClusterer = new markerClusterer.MarkerClusterer({
                                    map: me.map,
                                });
                            }
                            if (!me.DistanceKm) {
                                return;
                            }
                            //Render radius circle on map
                            if (!me.radiusCircle) {
                                me.radiusCircle = new google.maps.Circle({
                                    radius: (this.DistanceKm * 1000) / 2,
                                    center: this.Position,
                                    fillOpacity: 0.15,
                                    strokeOpacity: 0.05,
                                    map: this.map,
                                });
                            }
                            const bounds = new google.maps.Circle({
                                radius: (this.DistanceKm * 1000) / 2,
                                center: this.Position,
                            });
                            this.map.fitBounds(bounds.getBounds());
                            //CS.Ajax.Get($("#GetEventsNearMeUrl").val(), { filtersStateSerialized: me.filtersAreCollapsed }, (r) => {
                            const eventsJson = $("#map-locations").val();
                            if (eventsJson) {
                                const events = JSON.parse(eventsJson);
                                const allMarkers = events.map((ev, i) => {
                                    let marker = new google.maps.Marker({
                                        position: new google.maps.LatLng(ev.Latitude, ev.Longitude),
                                        //map: me.map,
                                        title: ev.Name,
                                        label: i.toString(),
                                        //icon: image
                                        //icon: (ev.EventType == 1 ? svgTournamentMarker : svgLeagueMarker)
                                    });
                                    //const glyphImg = document.createElement('img');
                                    //glyphImg.src = 'https://compusport.us/cdn/app/images/sports/darts.png';
                                    //const glyphImg = document.createElement('span');
                                    //glyphImg.innerHTML = i.toString();
                                    //let pinView = new google.maps.marker.PinView({
                                    //    background: ev.EventType == 1 ? 'blue' : 'red',
                                    //    glyph: glyphImg
                                    //});
                                    //let marker = new google.maps.marker.AdvancedMarkerView({
                                    //    position: new google.maps.LatLng(r[i].Latitude, r[i].Longitude),
                                    //    map: me.map,
                                    //    title: ev.Name,
                                    //    content: pinView.element
                                    //    //icon: image
                                    //    //icon: (r[i].EventType == "Tournament" ? svgTournamentMarker : svgLeagueMarker)
                                    //});
                                    //const image =
                                    //    "https://compusport.us/cdn/app/images/logo-compusport.png";
                                    //const svgTournamentMarker = {
                                    //    path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
                                    //    fillColor: "blue",
                                    //    fillOpacity: 0.6,
                                    //    strokeWeight: 0,
                                    //    rotation: 0,
                                    //    scale: 2,
                                    //    anchor: new google.maps.Point(15, 30),
                                    //};
                                    //const svgLeagueMarker = {
                                    //    path: "M10.453 14.016l6.563-6.609-1.406-1.406-5.156 5.203-2.063-2.109-1.406 1.406zM12 2.016q2.906 0 4.945 2.039t2.039 4.945q0 1.453-0.727 3.328t-1.758 3.516-2.039 3.070-1.711 2.273l-0.75 0.797q-0.281-0.328-0.75-0.867t-1.688-2.156-2.133-3.141-1.664-3.445-0.75-3.375q0-2.906 2.039-4.945t4.945-2.039z",
                                    //    fillColor: "red",
                                    //    fillOpacity: 0.6,
                                    //    strokeWeight: 0,
                                    //    rotation: 0,
                                    //    scale: 2,
                                    //    anchor: new google.maps.Point(15, 30),
                                    //};
                                    //if (navigator.geolocation) {
                                    //    navigator.geolocation.getCurrentPosition((p) => {
                                    //        me.Position = new google.maps.LatLng(p.coords.latitude, p.coords.longitude);
                                    //        console.log(p.coords.latitude);
                                    //        me.initMap();
                                    //    })
                                    //}
                                    let content = "";
                                    if (ev.ThumbnailUrl) {
                                        content += `<img src='https://compusport.us${ev.ThumbnailUrl}' />`;
                                    }
                                    content += `<span style='color:black'>${ev.Name}</span>`;
                                    const infowindow = new google.maps.InfoWindow({
                                        content: content,
                                        //ariaLabel: "Uluru",
                                    });
                                    marker.addListener("click", () => {
                                        infowindow.open(me.map, marker);
                                    });
                                    return marker;
                                });
                                //ne pas ajouter un marker si la même position est déja utilisée, pour éviter glitch de zoom
                                //TODO: quoi faire avec les events qui ont la meme position
                                me.markers = [allMarkers[0]];
                                allMarkers[0].setMap(me.map);
                                for (var j = 1; j < allMarkers.length; j++) {
                                    if (allMarkers[j].getPosition().lat() !=
                                        allMarkers[j - 1].getPosition().lat() ||
                                        allMarkers[j].getPosition().lng() !=
                                            allMarkers[j - 1].getPosition().lng()) {
                                        me.markers.push(allMarkers[j]);
                                        allMarkers[j].setMap(me.map);
                                    }
                                }
                                // Add a marker clusterer to manage the markers.
                                this.markerClusterer.addMarkers(me.markers);
                            }
                            //});
                        }
                        setStickyTop(accordion) {
                            var _a;
                            const $chips = accordion.$Content.find(".chips.filter-chips");
                            if (!$chips.length) {
                                return;
                            }
                            let topHeight = CS.DOM.$topBar.outerHeight();
                            topHeight += (_a = CS.DOM.$subTop.outerHeight()) !== null && _a !== void 0 ? _a : 0;
                            $chips.css("top", topHeight - 1);
                        }
                    }
                    WallSections.EventsFilteredSection = EventsFilteredSection;
                    CS.Controls.Accordion.Events.Rendered({
                        selector: "body",
                        childSelector: ".accordion-events-filtered",
                        callback: (accordion, e) => {
                            //EventsFilteredSection.instance.DistanceKm = $(".dropdown.events-distancekm-dropdown .selected").data("value");
                            EventsFilteredSection.instance.DistanceKm = $(".cs-filter-dropdown-picker[data-pickerof='dropdown-cs-filter-distance'] .item").data("value");
                            EventsFilteredSection.instance.registerRenderedEvents(accordion, e);
                            EventsFilteredSection.instance.initMap();
                            EventsFilteredSection.instance.setStickyTop(accordion);
                        },
                    });
                    CS.Controls.Accordion.Events.Resized({
                        selector: "body",
                        childSelector: ".accordion-events-filtered",
                        callback: (accordion, e) => {
                            EventsFilteredSection.instance.setStickyTop(accordion);
                        },
                    });
                    CS.Controls.Accordion.Events.Ready({
                        selector: "body",
                        childSelector: ".accordion-events-filtered",
                        callback: (accordion, e) => {
                            CS.DOM.$body.offon("initmap.eventswall", () => {
                                EventsFilteredSection.instance.initMap();
                            });
                            accordion.$Container.offon("click.eventswall", "#button-delete-last-searches", function (e) {
                                e.preventDefault();
                                e.stopImmediatePropagation();
                                const url = $("#DeleteLastSearchesUrl").val(), data = {};
                                CS.Ajax.Post(url, data, function (response) {
                                    if (response.Success) {
                                        CS.Nav.Refresh();
                                    }
                                });
                            });
                            EventsFilteredSection.instance.registerReadyEvents(accordion, e, "events");
                            let preventAutomaticTrigger = false;
                            const $input = CS.DOM.$body.find(".textbox-main-search.searchbar__input");
                            if ($input.length) {
                                $input.offon("keyup.mainsearchevents", (e) => {
                                    if (preventAutomaticTrigger)
                                        return;
                                    CS.Lag("main-search-events-tab", 1000, () => __awaiter(this, void 0, void 0, function* () {
                                        preventAutomaticTrigger = true;
                                        const text = $input.val().trim();
                                        const $overridableUrlHiddenInput = $(`#NameFilterOverridableUrl-${accordion.ContentId}`);
                                        if ($overridableUrlHiddenInput.length) {
                                            const overridableUrl = $overridableUrlHiddenInput.val();
                                            if (!CS.Helper.isNullOrWhiteSpace(overridableUrl)) {
                                                const _url = yield CS.Controls.Filters.ReplaceValueInOverridableUrl(overridableUrl, text, CS.Enumeration.FilterType.Name);
                                                if (!CS.Helper.isNullOrWhiteSpace(_url)) {
                                                    const url = WallSections.OpponentsSection.formatSectionUrl(_url, accordion);
                                                    accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                                        EventsFilteredSection.instance.updateUI(accordion);
                                                        yield CS.Controls.Filters.UpdateFiltersStateInBrowserUrlStatic(yield CS.Controls.Filters.ExtractFiltersStateFromUrl(url));
                                                        preventAutomaticTrigger = false;
                                                    }), url);
                                                }
                                            }
                                        }
                                    }));
                                });
                            }
                            accordion.$Content.offon("click.eventsfilteredtabmenu", `#tabmenu-main-search-events-tab-menu-${accordion.ContentId} .tab-menu-item`, (e) => __awaiter(this, void 0, void 0, function* () {
                                const $tab = $(e.currentTarget);
                                if ($tab.hasClass("is-highlighted"))
                                    return;
                                const _data = $tab.attr("data-html");
                                if (CS.Helper.isNullOrWhiteSpace(_data))
                                    return;
                                const data = JSON.parse(_data);
                                if (!data)
                                    return;
                                const { OverridableUrl, ToggleUrl, Value, FilterType } = data;
                                const shouldUseToggleUrl = CS.Helper.isNullOrWhiteSpace(OverridableUrl);
                                const _url = shouldUseToggleUrl
                                    ? ToggleUrl
                                    : yield CS.Controls.Filters.ReplaceValueInOverridableUrl(OverridableUrl, Value, FilterType);
                                if (CS.Helper.isNullOrWhiteSpace(_url))
                                    return;
                                const url = EventsFilteredSection.instance.formatSectionUrl(_url, accordion);
                                accordion.RefreshContent(() => __awaiter(this, void 0, void 0, function* () {
                                    EventsFilteredSection.instance.updateUI(accordion);
                                    yield CS.Controls.Filters.UpdateFiltersStateInBrowserUrlStatic(yield CS.Controls.Filters.ExtractFiltersStateFromUrl(url));
                                }), url);
                            }));
                            // accordion.$Content.offon(
                            //   "click.toggleSwitchLeagues",
                            //   `#events-wall-leagues-${accordion.ContentId}`,
                            //   (e) => {
                            //     const $dropdownItem = DOM.$body.find(
                            //       `.item[data-filter-type="${CS.Enumeration.FilterType.EventType}"][data-value="2"]`
                            //     );
                            //     if ($dropdownItem.length) {
                            //       $dropdownItem.trigger("click");
                            //     }
                            //   }
                            // );
                            // accordion.$Content.offon(
                            //   "click.toggleSwitchTournaments",
                            //   `#events-wall-tournaments-${accordion.ContentId}`,
                            //   (e) => {
                            //     const $dropdownItem = DOM.$body.find(
                            //       `.item[data-filter-type="${CS.Enumeration.FilterType.EventType}"][data-value="1"]`
                            //     );
                            //     if ($dropdownItem.length) {
                            //       $dropdownItem.trigger("click");
                            //     }
                            //   }
                            // );
                            // accordion.$Content.offon(
                            //   "click.toggleSwitchAllEventsType",
                            //   `#events-wall-all-events-${accordion.ContentId}`,
                            //   (e) => {
                            //     const $filterItem = DOM.$body.find(
                            //       `.filter[data-filter-type="${CS.Enumeration.FilterType.EventType}"]`
                            //     );
                            //     if ($filterItem.length) {
                            //       const $checkbox = $filterItem.find(".checkbox");
                            //       if ($checkbox.length) {
                            //         const checkbox = CS.Controls.GetInstance(
                            //           CS.Controls.CheckBox,
                            //           $checkbox,
                            //           true
                            //         );
                            //         if (checkbox != null) {
                            //           const currentValue = checkbox.GetValue();
                            //           if (currentValue == "true") {
                            //             $checkbox.trigger("click");
                            //           }
                            //         }
                            //       }
                            //     }
                            //   }
                            // );
                            const findNameFilterInput = () => $(`input[datafiltertype="${CS.Enumeration.FilterType.Name}"]`).closest(".textbox.control-cs.cs-filter-input");
                            CS.Controls.TextBox.Events.TextChanged({
                                selector: accordion.$Content,
                                childSelector: `#textbox-eventssectionviewmodelsearchbarinput-${accordion.ContentId}`,
                                callback: (textbox, e) => {
                                    const $nameFilterInput = findNameFilterInput();
                                    if ($nameFilterInput.length) {
                                        const $filterContainer = $nameFilterInput.closest(".filter-body");
                                        if ($filterContainer.length) {
                                            const nameFilterInput = CS.Controls.GetInstance(CS.Controls.TextBox, $nameFilterInput, true);
                                            if (nameFilterInput != null) {
                                                const textboxValue = textbox.GetValue();
                                                nameFilterInput.SetValue(textboxValue, true);
                                            }
                                        }
                                    }
                                },
                            });
                            CS.DOM.$body.offon("keyup.eventswall-mainsearchinput", `.textbox-main-search.searchbar__input`, (e) => {
                                const $input = $(e.currentTarget);
                                const $nameFilterInput = findNameFilterInput();
                                if ($nameFilterInput.length) {
                                    const $filterContainer = $nameFilterInput.closest(".filter-body");
                                    if ($filterContainer.length) {
                                        const nameFilterInput = CS.Controls.GetInstance(CS.Controls.TextBox, $nameFilterInput, true);
                                        if (nameFilterInput != null) {
                                            const textboxValue = $input.val().trim();
                                            nameFilterInput.SetValue(textboxValue, true);
                                        }
                                    }
                                }
                            });
                            // TODO: Implement FiltersV2
                        },
                    });
                })(WallSections = _Shared.WallSections || (_Shared.WallSections = {}));
            })(_Shared = Views._Shared || (Views._Shared = {}));
        })(Views = App.Views || (App.Views = {}));
    })(App = CS.App || (CS.App = {}));
})(CS || (CS = {}));

//# sourceMappingURL=events-filtered-section.js.map
